import script from "./LoadTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadTemplateModal.vue?vue&type=style&index=0&id=01c589ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c589ca"]])

export default __exports__